/**
 * Checks if user is authenticated
 */
const isUserAuthenticated = () => {
    const signInUserToken = getSignInUserToken();
    if (!signInUserToken) {
        return false;
    }
    return true;
}

/**
 *
 * @param signInUserToken
 */
const setSignInUserToken = (signInUserToken) => {
    localStorage.setItem('signInUserToken', signInUserToken);
}

/**
 *
 */
const getSignInUserToken = () => {
    const signInUserToken = localStorage.getItem('signInUserToken');
    return signInUserToken;
}

/**
 *
 * @returns {string}
 */
const cleanSignInUserToken = () => {
    localStorage.removeItem('signInUserToken');
}

/**
 *
 * @param signInCorpId
 */
const setSignInCorpId = (signInCorpId) => {
    localStorage.setItem('signInCorpId', signInCorpId);
}

/**
 *
 * @returns {string}
 */
const getSignInCorpId = () => {
    const signInCorpId = localStorage.getItem('signInCorpId');
    return signInCorpId;
}

/**
 *
 */
const cleanSignInCorpId = () => {
    localStorage.removeItem('signInCorpId');
}

/**
 *
 * @param signInUserId
 */
const setSignInUserId = (signInUserId) => {
    localStorage.setItem('signInUserId', signInUserId);
}

/**
 *
 * @returns {string}
 */
const getSignInUserId = () => {
    const signInUserId = localStorage.getItem('signInUserId');
    return signInUserId;
}




/**
 * export
 */
export {
    isUserAuthenticated,
    setSignInUserToken,
    setSignInCorpId,
    getSignInUserToken,
    getSignInCorpId,
    cleanSignInUserToken,
    cleanSignInCorpId,
    setSignInUserId,
    getSignInUserId
};
